// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + chunkId + "-" + {"167":"77f59722f5d64fd633e5","659":"a96cc1017a4f20e73418","799":"649fd82dadd1693858c0"}[chunkId] + ".js";
};